<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">啟動廣告設定</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="homepageimg1">
                    <div class="demo-image__preview" @click="handlesrcList(row.homepageimg1)">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="row.homepageimg1"
                            :preview-src-list="srcList">
                        </el-image>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="homepageimg2">
                    <div class="demo-image__preview" @click="handlesrcList(row.homepageimg2)">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="row.homepageimg2"
                            :preview-src-list="srcList">
                        </el-image>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="link">
                    <div class="pg-btn-wrap">
                        <a rel="shortcut icon" :href="row.url">{{row.url}}</a>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(row)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(row)">删除</div>
                    </div>
                </template>
                <template slot="status" slot-scope="{row,index}">
                        <Switchs true-color="#51f4a9" v-model="row.status" @on-change="statusChange(row)"/>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                  <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    </div>
</template>

<script>
   export default {
      data() {
         return {
            srcList: [],
            pageIndex: 1,
            curPageSize: 10,
            pageInput: '',
            isSubmiting: false,
            totalCount: 0,
            status: false,
            table: {
               column: [
                  {
                     title: '廣告名稱',
                     key: 'name',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '圖片一',
                     key: 'homepageimg1',
                     align: 'center',
                     slot: 'homepageimg1',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '圖片二',
                     key: 'homepageimg2',
                     align: 'center',
                     slot: 'homepageimg2',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '跳轉鏈接',
                     key: 'url',
                     slot: 'link',
                     align: 'center',
                     sortable: true,
                     minWidth: 160,
                  },
                  {
                     title: '上傳時間',
                     key: 'created_at',
                     align: 'center',
                     sortable: true,
                     minWidth: 160
                  },
                  {
                     title: '是否開啟',
                     key: 'status',
                     align: 'center',
                     slot: 'status',
                     sortable: true,
                     minWidth: 120
                  },
                  {
                     title: '操作',
                     slot: 'action',
                     align: 'center',
                     minWidth: 150
                  }
               ],
               data: []
            }
         };
      },
      activated() {
         this.getList();
      },
      mounted() {
         this.getList();
      },
      methods: {
        statusChange(item) {
            let id = item.id;
            let status;
            if (item.status) {
               status = 1;
            }else {
               status = 2;
            }
            this.isSubmiting = true;

            this.$Rq.requestAuth({
               url: this.$Api.advertiserManageEdit,
               method: 'post',
               data: {
                id: id,
                status: status,
              }
            }).then((res) =>
            {
               this.isSubmiting = false;
               this.getList();
               if (res.code == 1)
               {
                  this.$Utils.showSuccess(res.msg);
               } else
               {
                  this.$Utils.showTipInfo(res.msg);
               }
            }).catch((err) =>
            {
               this.isSubmiting = false;
            });
         },
         handlesrcList(imgobj){
            this.srcList = [];
            for (let i = 0; i < imgobj.length; i++)
            {
                this.srcList.push(imgobj);
            }
         },
         getList() {
            let form = this.form;
            this.isSubmiting = true;
            this.$Rq.requestAuth({
               url: this.$Api.advertiserManage,
               method: 'get',
               // data: {
                  // offset: (this.pageIndex - 1) * this.curPageSize,
                  // limit: this.curPageSize,
               // }
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 0) {
                  let tempArr = [];
                  let resData = res.data.data;
                  
                  for (let i = 0; i < resData.length; i++) {
                     let status;
                     let hompageimg1;
                     let hompageimg2;

                     if (resData[i].status == 0) {
                        status = false;
                     } else {
                        status = true;
                     }

                     tempArr.push({
                        id: resData[i].id,
                        name: resData[i].name,
                        homepageimg1: resData[i].homepageimg == null ? '- - -' : resData[i].homepageimg[0].path,
                        homepageimg2: resData[i].homepageimg == null ? '- - -' : resData[i].homepageimg[1].path,
                        sort: resData[i].sort,
                        url: resData[i].url,
                        created_at: resData[i].created_at,
                        status
                     });
                  }
                  this.totalCount = res.data.count;
                  this.table.data = tempArr;
               } else {
                  this.showTipInfo(res.msg);
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },
         handleDelete(item) {
            let id = item.id;
            this.$Modal.confirm({
               title: '提示',
               content: '確定刪除嗎？',
               cancelText: '取消',
               okText: '確定',
               onOk: () => {
                  let tableData = this.table.data;
                  this.isSubmiting = true;
                  this.$Rq.requestAuth({
                     url: this.$Api.advertiserManageDel,
                     method: 'post',
                     data:{
                        del_id: id
                     }
                  }).then((res) => {
                     this.isSubmiting = false;
                     if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.getList();
                     } else {
                        this.$Utils.showTipInfo(res.msg);
                     }
                  }).catch((err) => {
                     this.isSubmiting = false;
                  });
               }
            });
         },
         handleToAdd() {
            this.$router.push({path: '/advertiserManageAdd'});
         },
         handleSearch() {
            this.pageIndex = 1;
            this.getList();
         },
         handleEdit(item) {
            this.$router.push({path: '/advertiserManageEdit?id=' + item.id})
         },
         handlePageSizeChange(value) {
            this.pageIndex = 1;
            this.getList();
         },
         handlePageInput() {
            let value = ('' + this.pageInput).replace(/\D/g, '');
            let pageCount = Math.ceil(this.totalCount / this.curPageSize);
            if (value > pageCount) {
               value = pageCount;
            }
            this.pageInput = value;
         },
         handlePageEnter() {
            if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
            if (this.pageInput == 0) {
               this.pageInput = 1;
            }
            this.pageInput = parseInt(this.pageInput);
            this.pageIndex = this.pageInput;
            this.getList();
         },
         handlePageChange(value) {
            this.pageIndex = value;
            this.getList();
         }
      }
   };
</script>

<style lang="scss" scoped>
    @import 'advertiserManage.scss';
</style>